// vehicles
export const SET_VEHICLES = 'SET_VEHICLES';
export const SET_VEHICLE = 'SET_VEHICLE';
export const CLEAR_VEHICLES = 'CLEAR_VEHICLES';

// authentication
export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const SET_ACL_IN_REDUX = 'SET_ACL_IN_REDUX';

// new features tracking
export const MARK_FEATURE_AS_SEEN = 'MARK_FEATURE_AS_SEEN';
export const SET_LATEST_SEEN_VERSION = 'SET_LATEST_SEEN_VERSION';

// policy hubs
export const SET_ACTIVE_PHASE = 'SET_ACTIVE_PHASE'
export const TOGGLE_VISIBLE_LAYER = 'TOGGLE_VISIBLE_LAYER'
export const UNSET_VISIBLE_LAYER = 'UNSET_VISIBLE_LAYER'
export const SET_VISIBLE_LAYER = 'SET_VISIBLE_LAYER'
export const SET_VISIBLE_LAYERS = 'SET_VISIBLE_LAYERS'
export const SET_SELECTED_POLICY_HUBS = 'SET_SELECTED_POLICY_HUBS'
export const SET_SHOW_COMMIT_FORM = 'SET_SHOW_COMMIT_FORM'
export const SET_SHOW_EDIT_FORM = 'SET_SHOW_EDIT_FORM'
export const SET_SHOW_PROPOSE_DELETE_FORM = 'SET_SHOW_PROPOSE_DELETE_FORM'
export const SET_SHOW_LIST = 'SET_SHOW_LIST'
export const SET_HUBS_IN_DRAWING_MODE = 'SET_HUBS_IN_DRAWING_MODE'
export const SET_IS_DRAWING_ENABLED = 'SET_IS_DRAWING_ENABLED'
export const SET_HUB_REFETCH_COUNTER = 'SET_HUB_REFETCH_COUNTER'
export const SET_IS_STATS_OR_MANAGE_MODE = 'SET_IS_STATS_OR_MANAGE_MODE'

// layers
export const LAYER_SET_MAP_STYLE = 'LAYER_SET_MAP_STYLE'
export const LAYER_SET_DATA_LAYER_ORDER = 'LAYER_SET_DATA_LAYER_ORDER'
export const LAYER_TOGGLE_OVERLAY_LAYER = 'LAYER_TOGGLE_OVERLAY_LAYER'
export const LAYER_SET_OVERLAY_PHASE = 'LAYER_SET_OVERLAY_PHASE'

// search
export const SET_SEARCH_BAR_QUERY = 'SET_SEARCH_BAR_QUERY'

// service areas
export const SHOW_SERVICE_AREA_FOR_OPERATOR = 'SHOW_SERVICE_AREA_FOR_OPERATOR'
export const TOGGLE_SERVICE_AREA_FOR_OPERATOR = 'TOGGLE_SERVICE_AREA_FOR_OPERATOR'
